document.addEventListener('keydown', ({ altKey, key }) => {
  if (altKey && key.toLowerCase() === 'r') {
    document.body.classList.toggle('rulers');
  }
});

// Управление вспомогательными классами для выделения кольца фокуса при навигации с клавиатуры
document.body.addEventListener('mousedown', () => {
  document.body.classList.add('using-mouse');
});

document.body.addEventListener('keydown', () => {
  document.body.classList.remove('using-mouse');
});
